import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { passwordPattern } from '../../../config/password.config';
import { UnitService } from '../../../core/services/unit-service';
import { CategoryService } from '../../services/category.service';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.css'],
})
export class CreateCategoryComponent
  extends SecondPageEditBase
  implements OnInit
{
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];

  constructor(
    protected _categoryService: CategoryService,
    protected _injector: Injector,
  ) {
    super(_categoryService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl('', [Validators.required]),
      name: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
  }

  onShowPopup() {
    this.validationSummary.resetErrorMessages();
    this.resetForm();
    this.onReset();

    this.itemDetail.id = 0;
    this.itemDetail.status = 1;
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }
    
    this.onInsert();
  }

  onInsert() {
    this._categoryService.create(this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showInsertDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showInsertDataFailed();
        this.submitting = false;
      }
    );
  }
}
